import { render, staticRenderFns } from "./IntlPagination.vue?vue&type=template&id=ea54fe02&scoped=true"
import script from "./IntlPagination.vue?vue&type=script&lang=js"
export * from "./IntlPagination.vue?vue&type=script&lang=js"
import style0 from "./IntlPagination.vue?vue&type=style&index=0&id=ea54fe02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea54fe02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea54fe02')) {
      api.createRecord('ea54fe02', component.options)
    } else {
      api.reload('ea54fe02', component.options)
    }
    module.hot.accept("./IntlPagination.vue?vue&type=template&id=ea54fe02&scoped=true", function () {
      api.rerender('ea54fe02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/components/IntlPagination.vue"
export default component.exports